jQuery.noConflict();
(function ($) {
    $(document).ready(function () {
        $(".checkboxset input").addClass('option');

        $.validator.addClassRules("option", {
            required: function (e) {
                return $('.option:checked').length > 0 ? false : true;
            }
        });

        var validation = {
            submitHandler: function (form) {
                var url = $(form).attr('action');
                var data = $(form).serialize();
                var success = function (data) {
                    switch (data) {
                        case "sent":
                            $(form).html('<p>Vielen Dank! Wir haben Ihre Anfrage erhalten.</p>');
                            break;
                        case "unsent":
                            $('#validationError').html('<p>Fehler beim Formularversand.</p>').show(50);
                            break;
                        case "invalid":
                            $('#validationError').html('<p>Fehler bei der Verarbeitung der Daten.</p>').show(50);
                    }
                }
                $.post(url, data, success);
            },
            highlight: function (element, errorClass) {
                $(element).closest('.field').addClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).closest('.field').removeClass(errorClass);
            },
            focusInvalid: false,
            errorLabelContainer: "#errorLabels",
            errorElement: "span",
            showErrors: function (errorMap, errorList) {
                if(errorList.length) {
                    $("#validationError").html("<p>Bitte bearbeiten Sie die markierten Felder.</p>").show(50);
                } else {
                    $("#validationError").hide(50);
                }
                this.defaultShowErrors();
            },
            rules: {
                "Contact.FirstName": {required: true},
                "Contact.LastName": {required: true},
                "Contact.Email": {required: true},
                "Contact.Phone": {required: true},
                "Subject": {required: true},
                "Message": {required: true}
            }
        }

        $('.option').on('click', function(){
            if($('.option:checked').length){
                $('.checkboxset.error').removeClass('error');
            } else {
                $('.checkboxset').addClass('error');
            }
        });


        $(".field.addField").hide();

        $('#Form_Form_Quote').on('click', function () {
            if ($(this).is(':checked')) {
                $(".field.addField").show();
            } else {
                $(".field.addField").hide();
            }
        });

        $('#Form_Form').validate(validation);
    });
}(jQuery));